import React from 'react';
import type { WorkflowType } from '@this/domain/organization/organization2';
import {
  BufferAmountInput,
  ContentLabel,
  SubSectionContent,
  WorkflowOption
} from '@this/components/organization/setting/workflow_setting_section/shared';

const styles = {
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '10px',
    marginLeft: '16px'
  },
  radioGroup: {
    display: 'flex',
    gap: '10px'
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center'
  }
};

interface WorkflowSectionProps {
  description: string;
  itemLabel: string;
  workflowType: WorkflowType;
  bufferAmount: number;
  target: string;
  showPriceLimitOption?: boolean;
  onChangeWorkflowType: (type: WorkflowType, target: string) => void;
  onChangeBufferAmount: (amount: number, target: string) => void;
}

const WorkflowSection: React.FC<WorkflowSectionProps> = ({
  description,
  itemLabel,
  workflowType,
  bufferAmount,
  target,
  showPriceLimitOption = false,
  onChangeWorkflowType,
  onChangeBufferAmount
}) => {
  const idPrefix = target.toLowerCase();

  return (
    <SubSectionContent>
      {description && <ContentLabel>{description}</ContentLabel>}
      <div style={styles.optionsContainer}>
        <div style={styles.radioGroup}>
          <WorkflowOption
            id={`${idPrefix}-selected-amount`}
            type="selected_amount"
            selectedType={workflowType}
            label={`選択した${itemLabel}の金額を申請額とする`}
            onChange={() => onChangeWorkflowType('selected_amount', target)}
          />
          {showPriceLimitOption && (
            <WorkflowOption
              id={`${idPrefix}-price-limit`}
              type="price_limit"
              selectedType={workflowType}
              label="旅費規定金額を申請額とする"
              onChange={() => onChangeWorkflowType('price_limit', target)}
            />
          )}
          <WorkflowOption
            id={`${idPrefix}-with-buffer`}
            type="with_buffer"
            selectedType={workflowType}
            label={`選択した${itemLabel}の金額＋固定金額をバッファとして設定する`}
            onChange={() => onChangeWorkflowType('with_buffer', target)}
          />
        </div>
        {workflowType === 'with_buffer' && (
          <BufferAmountInput amount={bufferAmount} onChange={value => onChangeBufferAmount(value, target)} />
        )}
      </div>
    </SubSectionContent>
  );
};

export default WorkflowSection;
